import { FC } from "react";

export const OrderProgressSteps: FC = () => null;
